__turbopack_context__.v({
  "gridContainer": "OutletOrderFormats-module-scss-module__AH20IW__gridContainer",
  "orderFormatIcon": "OutletOrderFormats-module-scss-module__AH20IW__orderFormatIcon",
  "selected": "OutletOrderFormats-module-scss-module__AH20IW__selected",
});
